
import React from "react";
import { Workflow, GraduationCap, Map } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const HowSection = () => {
  return (
    <section className="py-16 bg-earth-50">
      <div className="container">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white mb-6">
            <Workflow className="w-5 h-5 text-eco-500 mr-2" />
            <span className="font-semibold text-eco-700">How</span>
          </div>
          <h2 className="text-3xl font-bold mb-6 text-eco-700">
            A not-for-profit project mapping sustainable communities
          </h2>
          <p className="text-lg text-muted-foreground mb-6">
            Ourcelium is a not-for-profit project that maps out the people, places and projects 
            shaping a more sustainable and soulful way of life across the UK.
          </p>
          <p className="text-lg text-muted-foreground mb-6">
            It's a simple, quiet tool. No ads. No algorithms. Just a growing directory 
            of what's already happening on the ground.
          </p>
          <p className="text-lg text-muted-foreground">
            We're currently testing it out, updating as we go and listening to the community. 
            For now, it's free to use. When the time feels right, we'll invite small donations 
            to help cover the basics and keep it going.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mt-12">
          <Card className="bg-white border-earth-100">
            <CardContent className="pt-6">
              <GraduationCap className="w-10 h-10 text-eco-500 mb-4" />
              <h3 className="text-xl font-semibold mb-3">Community-Led</h3>
              <p className="text-muted-foreground">
                We believe in the power of local communities to create meaningful, 
                lasting environmental and social change.
              </p>
            </CardContent>
          </Card>
          
          <Card className="bg-white border-earth-100">
            <CardContent className="pt-6">
              <Map className="w-10 h-10 text-eco-500 mb-4" />
              <h3 className="text-xl font-semibold mb-3">Transparent</h3>
              <p className="text-muted-foreground">
                We provide clear information about businesses and their 
                sustainability practices to help people make informed choices.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default HowSection;
